import { Element } from "@api/models/Element";
import { VideoController } from "@service/components/player-panel/types/VideoController";
import { EventInterface } from "@share/program/types/EventInterface";
import {MutationTree} from "vuex";
import {MiniPlayerState } from "../types/MiniPlayerState";

export const mutations: MutationTree<MiniPlayerState> = {
    setObject(state, payload: Element | EventInterface) {
        state.object = payload;
    },
    setVideoController(state, payload: VideoController) {
        state.videoController = payload;
    },
    setShowPlayer(state, payload: boolean) {
        state.showPlayer = payload;
    },
    setPaused(state, payload: boolean) {
        state.paused = payload;
    },
    setReturnRouteName(state, payload: string) {
        state.returnRouteName = payload;
    }
}